import { render, staticRenderFns } from "./qs4-02.vue?vue&type=template&id=2240f60e&scoped=true&"
import script from "./qs4-02.vue?vue&type=script&lang=js&"
export * from "./qs4-02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2240f60e",
  null
  
)

export default component.exports